import { render } from "./BusinessPage.vue?vue&type=template&id=6b725bd2&scoped=true"
import script from "./BusinessPage.vue?vue&type=script&lang=js"
export * from "./BusinessPage.vue?vue&type=script&lang=js"

import "./BusinessPage.vue?vue&type=style&index=0&id=6b725bd2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b725bd2"]])

export default __exports__